import React, {Component} from 'react';
import ReactModal from 'react-modal';
import {connect} from "react-redux";
import PersonalPropertyApi from "../../../api/PersonalProperty";

class ExportToNewListingModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userId: ''
        }
    }

    handleInputChange(event) {
        const newState = {};
        newState[event.target.name] = event.target.value;

        this.setState(newState);
    }

    onClose(event) {
        event.preventDefault();

        this.props.onClose();
    }

    addAirbnbExport(event) {
        event.preventDefault();

        PersonalPropertyApi.addAirbnbExport(this.props.propertyId, this.state.userId).then(() => {
            this.props.onClose();
        })
    }

    render() {
        return (
            <ReactModal
                className="custom-react-modal external-calendars-modal"
                isOpen={this.props.isOpen}
                overlayClassName="custom-react-modal-overlay"
            >
                <form className="light">
                    <div className="external-calendars-modal_close">
                        <i className="fa fa-close" onClick={::this.onClose}/>
                    </div>

                    <div className="external-calendars-modal_title">
                        Export To New Listing
                    </div>

                    <div className="external-calendars-modal_form">
                        <label>
                            Airbnb UserId:
                            <input
                                name="userId"
                                value={this.state.userId}
                                onChange={::this.handleInputChange}
                                ref={input => {
                                    this.name = input;
                                }}
                            />
                        </label>
                    </div>

                    <br/>
                    <button className="btn" onClick={::this.addAirbnbExport}>
                        Do export
                    </button>
                </form>
            </ReactModal>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ExportToNewListingModal);


// WEBPACK FOOTER //
// ./src/components/CreatingProperty/airbnbCm/ExportToNewListingModal.js